// TODO: Move global messages type declaration from timr.d.ts here
// TIMR-11615 Refactor timr.d.ts

/**
 * Format message with arguments
 *
 * Format placeholder: {<indexOfArgument>}
 *
 * @param code message code
 * @param args arguments
 */
messages.withArguments = function (code, ...args: (string | number | boolean)[]): string {
	const message = messages[code] ?? "";
	return message.replace(/\{(\d+)\}/g, (match, index: string) => {
		// Convert index to a number and get the corresponding argument
		const argIndex = parseInt(index, 10);
		return String(args[argIndex] ?? match);
	});
};
